import { wrapRootElement as wrap } from "./src/templates/mdx-wrapper"
require("prismjs/themes/prism-solarizedlight.css")

export const wrapRootElement = wrap
